import React, { useState, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import axios from 'axios';
import './schedule.css';

const Group = ({ group }) => {
    const [{ isDragging }, drag] = useDrag({
        type: 'GROUP',
        item: { 
            id: group.id, 
            name: group.name, 
            type: group.type,
            sectionPeriodId: group.sectionPeriodId // For scheduling context
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    useEffect(() => {
        if (isDragging) {
            console.log(`Dragging group: ${group.name} (${group.type})`);
        }
    }, [isDragging, group.name, group.type]);

    const getTypeLabel = (type) => {
        switch (type) {
            case 'core': return 'Core';
            case 'cte': return 'CTE';
            case 'homeroom': return 'HR';
            default: return '';
        }
    };

    return (
        <div
            ref={drag}
            className="group-item"
            style={{ opacity: isDragging ? 0.5 : 1 }}
        >
            <span className="group-name">{group.name}</span>
            {group.type && (
                <span className="group-type-badge">[{getTypeLabel(group.type)}]</span>
            )}
        </div>
    );
};

const DraggableGroups = ({ gradeLevelId }) => {
    const [groups, setGroups] = useState([]);
    const [gradeLevelName, setGradeLevelName] = useState("");

    useEffect(() => {
        if (gradeLevelId) {
            // Fetch groups from all new group model types
            const fetchAllGroups = async () => {
                try {
                    const [coreResponse, cteResponse, homeroomResponse] = await Promise.all([
                        axios.get(`/api/groups/core-groups/grade-level-data/${gradeLevelId}/`),
                        axios.get(`/api/groups/cte-groups/grade-level-data/${gradeLevelId}/`),
                        axios.get(`/api/groups/homeroom-groups/grade-level-data/${gradeLevelId}/`)
                    ]);

                    // Combine all groups from different types
                    const allGroups = [
                        ...(coreResponse.data.groups || []).map(group => ({...group, type: 'core'})),
                        ...(cteResponse.data.groups || []).map(group => ({...group, type: 'cte'})),
                        ...(homeroomResponse.data.groups || []).map(group => ({...group, type: 'homeroom'}))
                    ];

                    setGroups(allGroups);
                } catch (error) {
                    console.error('Error fetching groups:', error);
                    setGroups([]);
                }
            };

            fetchAllGroups();
        }
    }, [gradeLevelId]);

    useEffect(() => {
        if (gradeLevelId) {
            axios.get(`/courses/api/grade_levels/${gradeLevelId}/`)
                .then(response => {
                    const data = response.data || {};
                    // Support multiple possible field names from the API
                    const name = data.name || data.grade || data.display_name || '';
                    setGradeLevelName(name);
                })
                .catch(error => {
                    console.error('Error fetching grade level name:', error);
                    setGradeLevelName('');
                });
        } else {
            setGradeLevelName('');
        }
    }, [gradeLevelId]);

    return (
        <div className="available-groups">
            <h3>Available Groups for {gradeLevelName} Grade</h3>
            {groups.length > 0 ? (
                groups.map(group => (
                    <Group key={group.id} group={group} />
                ))
            ) : (
                <p>No groups available for this grade level.</p>
            )}
        </div>
    );
};

export default DraggableGroups;
